import GamesConfig from "./GamesConfig"
import { Global } from "../Shared/Global";
import GameList from "../Models/GameList";
import Constant from "../Shared/Constant";
import SimpleScrollView from "../Common/SimpleScrollView";
const i18n = require("LanguageData");
const { ccclass, property } = cc._decorator;

@ccclass
export default class ChessAndCardLayer extends cc.Component {
    @property(SimpleScrollView)
    scrollView: SimpleScrollView = null

    @property(cc.Node)
    nodeContent: cc.Node = null

    private _selectedNode: cc.Node = null
    private _firstNodeItem: cc.Node = null
    private _lastNodeItem: cc.Node = null
    private _isFixingPosition: boolean = false

    onLoad() {
        this.nodeContent.removeAllChildren()

        if (cc.winSize.width / cc.winSize.height > 2) {
            this.scrollView.getComponent(cc.Widget) && (this.scrollView.getComponent(cc.Widget).left += Constant.BangLength)
        }

        cc.director.on(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onEnable() {
        this.checkItemsPosition()
    }

    onDestroy() {
        cc.director.off(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    update(dt) {
        this._isFixingPosition && this.checkItemsPosition()
    }

    onScrollViewEvent(simpleScrollView, eventType: Global.SimpleScrollViewEventType) {
        if (eventType === Global.SimpleScrollViewEventType.SCROLL_BEGAN) {
            this._isFixingPosition = false
            this.selectedNode(null)
        } else if (eventType === Global.SimpleScrollViewEventType.SCROLL_ENDED) {
            this.checkSelectedNode()
        } else if (eventType === Global.SimpleScrollViewEventType.SCROLLING) {
            this.checkItemsCircle()
            this.checkItemsPosition()
        }
    }

    private createNodeItems() {
        if (!GameList.serverData) {
            return
        }

        let gameCfgs = GameList.getGameListByType(Global.GameType.Chess)
        let items = gameCfgs["twoLevelList"] || []
        let loadCount = 0

        items.forEach(item => {
            let node = new cc.Node()
            let nodeSpine = new cc.Node()
            let skeleton = nodeSpine.addComponent(sp.Skeleton)
            let button = node.addComponent(cc.Button)
            let res = GamesConfig.chessandcard[item.platform]

            nodeSpine.name = "nodeSpine"
            nodeSpine.parent = node
            node.width = 290
            node.height = 460
            node.parent = this.nodeContent
            node.zIndex = this.nodeContent.children.length
            this.nodeContent.width = this.nodeContent.children.length * node.width
            node.x = node.width / 2 + (this.nodeContent.children.length - 1) * node.width

            if (!res) {
                res = "Hall/ChessAndCard/qipai_00"

                if (Constant.RemindMissingRes) {
                    let nodeLabel = new cc.Node()
                    let lbLack = nodeLabel.addComponent(cc.Label)

                    nodeLabel.color = cc.color(255, 0, 0)
                    nodeLabel.parent = node
                    lbLack.string = item.gameTitleCn + "\n" + i18n.t('CheckHot.lack_resources') + "!"
                    lbLack.fontSize = 40
                }
            }

            if (item === items[0]) {
                this._firstNodeItem = node
            } else if (item === items[items.length - 1]) {
                this._lastNodeItem = node
            }

            cc.loader.loadRes(res, sp.SkeletonData, function (err, skeletonData) {
                if (!err && this.node) {
                    skeleton.skeletonData = skeletonData
                    skeleton.animation = "an_00"
                }

                loadCount++
                this.checkItemsPosition()

                if (loadCount === items.length) {
                    this.checkSelectedNode()
                }
            }.bind(this))

            // 特殊处理热门图标
            if (["YG", "LY", "NW"].indexOf(item.platform) !== -1) {
                let nodeHot = new cc.Node()
                let spHot = nodeHot.addComponent(cc.Sprite)

                nodeHot.setAnchorPoint(cc.v2(1, 1))
                nodeHot.position = cc.v2(node.width * 0.45, node.height * 0.52)
                nodeHot.scale = 0.6
                nodeHot.parent = node

                cc.loader.loadRes("Common/hot", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spHot && spHot.isValid) {
                        spHot.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }

            // 名字
            let nodeName = new cc.Node()
            let lbName = nodeName.addComponent(cc.Label)
            let outlineName = nodeName.addComponent(cc.LabelOutline)
            nodeName.parent = nodeSpine
            nodeName.name = "nodeName"
            nodeName.width = 220
            nodeName.height = 60
            nodeName.position = cc.v2(0, -158)
            nodeName.skewX = 8
            lbName.string = item.gameTitleCn
            lbName.horizontalAlign = cc.Label.HorizontalAlign.CENTER
            lbName.useSystemFont = true
            lbName.fontSize = 42
            lbName.lineHeight = 42
            lbName.overflow = cc.Label.Overflow.SHRINK
            lbName["enableBold"] = true
            outlineName.color = cc.color(0, 59, 159)
            outlineName.width = 3

            // 游戏维护
            if (item.gameStatus === "2") {
                let nodeMaintenance = new cc.Node()
                let spMaintenance = nodeMaintenance.addComponent(cc.Sprite)
                
                nodeMaintenance.parent = nodeSpine
                nodeMaintenance.position = cc.v2(86, -165)
                nodeSpine.color = cc.color(70, 70, 70)
                nodeName.color = cc.color(70, 70, 70)
                outlineName.color = cc.color(0, 59 * 0.3, 159 * 0.3)

                cc.loader.loadRes("Common/maintenance", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spMaintenance && spMaintenance.isValid) {
                        spMaintenance.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }

            let clickEventHandler = new cc.Component.EventHandler()
            clickEventHandler.target = cc.find("Canvas/gameNode")
            clickEventHandler.component = "HallUI"
            clickEventHandler.handler = "onGameItemClick"
            button.clickEvents.push(clickEventHandler)
            button.node["gameConfig"] = item
        });
    }

    private selectedNode(node: cc.Node) {
        if (this._selectedNode === node) {
            return
        }

        if (this._selectedNode) {
            this._selectedNode.scale /= 1.05
            this._selectedNode.getChildByName("nodeSpine").getComponent(sp.Skeleton).animation = "an_00"

            if (this._selectedNode["gameConfig"].gameStatus === "2") {
                cc.find("nodeSpine/nodeName", this._selectedNode).getComponent(cc.LabelOutline).color = cc.color(0, 59 * 0.3, 159 * 0.3)
            }else {
                cc.find("nodeSpine/nodeName", this._selectedNode).getComponent(cc.LabelOutline).color = cc.color(0, 59, 159)
            }
        }

        this._selectedNode = node

        if (this._selectedNode) {
            this._selectedNode.scale *= 1.05
            this._selectedNode.getChildByName("nodeSpine").getComponent(sp.Skeleton).animation = "liang_00"
            this.fixPosition()
            
            if (this._selectedNode["gameConfig"].gameStatus === "2") {
                cc.find("nodeSpine/nodeName", this._selectedNode).getComponent(cc.LabelOutline).color = cc.color(229 * 0.3, 54 * 0.3, 0)
            }else {
                cc.find("nodeSpine/nodeName", this._selectedNode).getComponent(cc.LabelOutline).color = cc.color(229, 54, 0)
            }
        }
    }

    private checkItemsCircle() {
        if (this.scrollView.node.convertToNodeSpaceAR(this._firstNodeItem.convertToWorldSpaceAR(cc.v2(0, 0))).x >= -this.scrollView.node.width / 2) {
            this._lastNodeItem.parent = null
            this._lastNodeItem.parent = this.nodeContent
            this._lastNodeItem.x = this._firstNodeItem.x - this._firstNodeItem.width
            this._lastNodeItem.zIndex = this._firstNodeItem.zIndex - 1
            this.nodeContent.sortAllChildren()
            this._firstNodeItem = this._lastNodeItem
            this._lastNodeItem = this.nodeContent.children[this.nodeContent.children.length - 1]
            this.scrollView.setContentPosition(cc.v2(this.nodeContent.x - this._lastNodeItem.width, this.nodeContent.y))

            this.nodeContent.children.forEach(node => {
                node.x += node.width
            });
        }

        if (this.scrollView.node.convertToNodeSpaceAR(this._lastNodeItem.convertToWorldSpaceAR(cc.v2(0, 0))).x <= this.scrollView.node.width / 2) {
            this._firstNodeItem.parent = null
            this._firstNodeItem.parent = this.nodeContent
            this._firstNodeItem.x = this._lastNodeItem.x + this._lastNodeItem.width
            this._firstNodeItem.zIndex = this._lastNodeItem.zIndex + 1
            this.nodeContent.sortAllChildren()
            this._lastNodeItem = this._firstNodeItem
            this._firstNodeItem = this.nodeContent.children[0]
            this.scrollView.setContentPosition(cc.v2(this.nodeContent.x + this._lastNodeItem.width, this.nodeContent.y))

            this.nodeContent.children.forEach(node => {
                node.x -= node.width
            });
        }
    }

    private checkItemsPosition() {
        this.nodeContent.children.forEach(node => {
            if (node !== this._selectedNode) {
                let x = this.scrollView.node.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2(0, 0))).x
                node.scale = 1.12 - (Math.abs(x) * 0.38 / (this.scrollView.node.width / 2))
            }
        });
    }

    private checkSelectedNode() {
        let curNode = null

        this.nodeContent.children.forEach(node => {
            if (!curNode || node.scale > curNode.scale) {
                curNode = node
            }
        });

        if (curNode) {
            this.selectedNode(curNode)
        }
    }

    private fixPosition() {
        if (!this._selectedNode) return
        this._isFixingPosition = true
        let deltaX = this._selectedNode.convertToNodeSpaceAR(this.scrollView.node.convertToWorldSpaceAR(cc.v2(0, 0))).x
        this.nodeContent.runAction(cc.sequence(cc.moveBy(0.2, deltaX, 0).easing(cc.easeSineOut()), cc.callFunc(function () {
            this._isFixingPosition = false
        }.bind(this))))
    }
}
